export default "__VITE_ASSET__BISe2Mxa__"